<template>
    <section class="col s12">
        <textarea style="width: 100%; min-height: 150px;"
                  name="observacoesAnalistaTecnico"
                  id="observacoesAnalistaTecnico"
                  disabled
                  maxlength="1500"
                  v-model="observacoesAnalistaTecnico"
                  cols="30" rows="10"
                  class="browser-default"></textarea>
    </section>
</template>

<script>
export default {
    name: "observacoes_analista_tecnico",
    props: {
        pObservacoesAnalistaTecnico: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            observacoesAnalistaTecnico: this.pObservacoesAnalistaTecnico,
        }
    },
    watch: {
        pObservacoesAnalistaTecnico(newValue) {
            this.observacoesAnalistaTecnico = newValue
        },
    },
}
</script>

<style scoped>

</style>
